import { Select } from '@mantine/core';

import { getConversionPairTitle } from '@/modules/conversion-pairs';

import type { UseFormReturnType } from '@mantine/form';
import type { TConversionPair } from '@/modules/conversion-pairs';

type Props<T> = {
  conversionPairs: TConversionPair[];
  form: UseFormReturnType<T, (values: T) => T>;
};

export function ConversionPairFormField<T>(props: Props<T>) {
  const {
    conversionPairs,
    form,
  } = props;

  const conversionPairsPlaceholder = conversionPairs.length === 0 ? 'Нет доступных торговых пар' : 'Без конвертации';

  return (
    <Select
      label="Торговая пара"
      placeholder={conversionPairsPlaceholder}
      clearable
      data={conversionPairs.map((pair) => ({
        value: pair.id.toString(),
        label: `${pair.id} - ${getConversionPairTitle(pair)}`,
      }))}
      key={form.key('conversionPairId')}
      {...form.getInputProps('conversionPairId')}
    />
  );
}
